import { css } from 'styled-components';
import token from 'styled-token';
import { BUTTON_SIZES, BUTTON_TYPES } from '../../constants';
import { buttonStateMixin } from '../buttonStateMixin';
import { disabledMixin } from '../disabledMixin';
import { focusMixin } from '../focusMixin';
import { hoverMediaQueryMixin } from '../hoverMediaQueryMixin';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { sizeMixin } from '../sizeMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var fluidCSS = function fluidCSS(mediaProps) {
  return css(["width:", ";"], mediaProps.fluid ? '100%' : 'auto');
};
/** @class ButtonMixin */
/** @method */
export var ButtonMixin = function ButtonMixin(props) {
  var size = props.size,
    buttonType = props.buttonType,
    disabled = props.disabled;
  return token({
    borderRadius: 'Button.borderRadius',
    borderWidth: 'Button.borderWidth',
    fontType: "Button.fontType" + (size === BUTTON_SIZES.sm ? 'Small' : ''),
    horizontalPadding: 'Button.horizontalPadding',
    targetSize: 'Button.targetSize',
    margin: 'Button.margin',
    transitionDuration: 'Button.transitionDuration',
    transitionProperty: 'Button.transitionProperty',
    transitionTimingFunction: 'Button.transitionTimingFunction',
    pressedBorderWidth: 'Button.pressed.borderWidth',
    pressedHorizontalPadding: 'Button.pressed.horizontalPadding'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth,
      fontType = _ref.fontType,
      horizontalPadding = _ref.horizontalPadding,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? 0 : _ref$margin,
      targetSize = _ref.targetSize,
      _ref$transitionDurati = _ref.transitionDuration,
      transitionDuration = _ref$transitionDurati === void 0 ? 0.2 : _ref$transitionDurati,
      _ref$transitionProper = _ref.transitionProperty,
      transitionProperty = _ref$transitionProper === void 0 ? 'background-color, border-color, color' : _ref$transitionProper,
      _ref$transitionTiming = _ref.transitionTimingFunction,
      transitionTimingFunction = _ref$transitionTiming === void 0 ? 'ease' : _ref$transitionTiming,
      _ref$pressedBorderWid = _ref.pressedBorderWidth,
      pressedBorderWidth = _ref$pressedBorderWid === void 0 ? 2 : _ref$pressedBorderWid,
      pressedHorizontalPadding = _ref.pressedHorizontalPadding;
    return css(["cursor:pointer;text-decoration:none;text-align:center;display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;border:", "px solid;border-radius:", "px;user-select:none;padding-left:", "px;padding-right:", "px;margin:", "px;-webkit-appearance:none;transition-property:", ";transition-duration:", "s;transition-timing-function:", ";pointer-events:", ";", " ", " &,&:focus,&:visited,&:disabled{", "}", " &[aria-pressed=\"true\"][aria-pressed=\"true\"]{", " ", "}&:active:not(:disabled){", "}position:relative;&:after{content:'';position:absolute;left:0;height:", "px;min-width:", "px;width:100%;top:50%;margin-top:-", "px;}", " ", " ", " ", ""], borderWidth, borderRadius, horizontalPadding, horizontalPadding, margin, transitionProperty, transitionDuration, transitionTimingFunction, disabled ? 'none' : 'auto', focusMixin(props), inlineMediaQueryMixin('fluid', fluidCSS)(props), buttonStateMixin()(props), hoverMediaQueryMixin(buttonStateMixin('Hover')(props)), buttonStateMixin('Pressed')(props), buttonType === BUTTON_TYPES.tertiary ? "\n          border-width: " + pressedBorderWidth + "px;\n          padding-left: " + (pressedHorizontalPadding ? pressedHorizontalPadding + "px" : horizontalPadding - 1 + "px") + ";\n          padding-right: " + (pressedHorizontalPadding ? pressedHorizontalPadding + "px" : horizontalPadding - 1 + "px") + ";\n          " + sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 4
    })(props) + "\n        " : null, buttonStateMixin('Active')(props), targetSize, targetSize, targetSize / 2, typographyMixin(Object.assign({
      fontType: fontType
    }, props)), disabledMixin(props), sizeMixin({
      fontType: fontType,
      borderWidth: borderWidth * 2
    })(props), spacingMixin(props));
  })(props);
};